import { render, staticRenderFns } from "./TechnicalDemand.vue?vue&type=template&id=2d880f07&scoped=true"
import script from "./TechnicalDemand.vue?vue&type=script&lang=js"
export * from "./TechnicalDemand.vue?vue&type=script&lang=js"
import style0 from "./TechnicalDemand.vue?vue&type=style&index=0&id=2d880f07&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d880f07",
  null
  
)

export default component.exports